package com.macrofocus.eflux.components

import com.macrofocus.eflux.EFlux
import react.FC
import react.PropsWithChildren
import react.createRequiredContext

val EFluxContext = createRequiredContext<EFlux>()

external interface EFluxModuleProps : PropsWithChildren {
    var eflux: EFlux
}

val EFluxModule = FC<EFluxModuleProps> { props ->
//    val diviso = useDiviso()

    EFluxContext(props.eflux) {
        +props.children
    }
}